export default {
  relevant: "relevant".toUpperCase(),
  always: "always".toUpperCase(),
};
